import { IMAGES, GALLERY_ITEMS, img } from "../data/content";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

export const Gallery = () => (
  <Section
    id="gallery"
    eyebrow="Gallery"
    title="The room, in frames"
    intro="A glimpse of the mood — warm light, honest plates and corners made for conversation."
  >
    <div className="columns-2 gap-4 md:columns-3" data-testid="gallery-grid">
      {GALLERY_ITEMS.map((item, i) => (
        <Reveal key={item.caption} delay={(i % 3) * 0.08} className="mb-4 break-inside-avoid">
          <figure
            className="group relative overflow-hidden rounded-xl"
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={img(IMAGES[item.image], 800)}
              alt={item.alt}
              className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#141210]/90 to-transparent p-4 pt-10 text-sm italic text-[#e8e2d8] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              {item.caption}
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
    <Reveal delay={0.15}>
      <p className="mt-8 text-xs italic text-[#8f887f]" data-testid="gallery-stock-note">
        Curated stock photography is shown for this presentation — official photographs of Roma's
        will take their place.
      </p>
    </Reveal>
  </Section>
);
